// *** ProfileBio Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import createbuild from "../../assets/img/post/add-pop-thumb.svg";
import { attendEvent } from "../../services/apiEvent";


const AttendPopUp = (props) => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const attendEvents = async (id) => {
        const formData = {
            eventid: id,
            userid: userData._id
        }
        let attendCommunityEvent = await attendEvent(formData);
        if (attendCommunityEvent.status) {
            props.listEvent()
            props.handleClose();

        }

    };

    return (
        <div>
            <Modal show={props.isAttend} onHide={props.handleClose} dialogClassName="small-custom-modal  modal-dialog-centered">

                <Modal.Body>
                    <div >
                        <div className="altr-icon">
                            <img src={createbuild} className="succ-icon"></img>
                            {/* use this styles for success popup content @remya @raga */}
                        </div>
                        <div >
                            <p className="fov-text text-center" >
                                {props.mode === 'attend'
                                    ? "Are you sure you want to attend this event?"
                                    : "Are you sure you want to cancel your attendance for this event?"}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="full-w modal-footer" >
                    <button type="button" class="cancel-btn" onClick={() => props.handleClose()}> No</button>
                    <button class="next-btn" onClick={() => attendEvents(props.eventId)}>Yes</button>
                </Modal.Footer>


            </Modal>

        </div >
    );
};
export default AttendPopUp;
